import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

const headers = { 'Content-Type': 'application/json' };

const handle = (err) => {
    if (err.response?.data) throw err.response.data;
    throw err;
};

// GET the store closing/suspend/reschedule types (data-driven — Id/Name pairs)
export const getStoreClosingType = async () => {
    try {
        const res = await axios.get(`${API_BASE_URL}/Purchase/StoreClosingType`, { headers });
        return res.data;
    } catch (err) { handle(err); }
};

// GET the cost centers eligible for the chosen closing type
export const getStoreClosingCCs = async (ClosingType, UID, RID) => {
    try {
        const res = await axios.get(
            `${API_BASE_URL}/Purchase/GetStoreClosingCCS?ClosingType=${encodeURIComponent(ClosingType)}&UID=${encodeURIComponent(UID)}&RID=${encodeURIComponent(RID)}`,
            { headers }
        );
        return res.data;
    } catch (err) { handle(err); }
};

// GET pending workflow approvals still open at this cost center (Type is always
// "Store", matching the legacy page's constant) — a non-empty list blocks closing.
export const getCCStorePendings = async (CCCode) => {
    try {
        const res = await axios.get(
            `${API_BASE_URL}/Accounts/GetCCStorePendings?CCCode=${encodeURIComponent(CCCode)}&Type=Store`,
            { headers }
        );
        return res.data;
    } catch (err) { handle(err); }
};

// GET remaining stock balance at this cost center — a non-empty list blocks closing.
export const getCCBalanceStock = async (CCCode) => {
    try {
        const res = await axios.get(
            `${API_BASE_URL}/Accounts/GetCCBalanceStock?CCCode=${encodeURIComponent(CCCode)}`,
            { headers }
        );
        return res.data;
    } catch (err) { handle(err); }
};

// POST — finalize the store close/suspend/reschedule request
// payload: { ClosingType, ClosingCCs, ClosingDate, StartDate, EndDate, Alertnote,
//            UserRemarks, RoleID, UserID, Createdby }
export const saveStoreClosingData = async (payload) => {
    try {
        const res = await axios.post(
            `${API_BASE_URL}/Purchase/SaveStoreClosingData`,
            payload,
            { headers, timeout: 30000 }
        );
        return res.data;
    } catch (err) { handle(err); }
};
